import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";
import { useUniqueId } from "../../Hooks";

const EventSpace: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 20, ...rest }, ref) => {
   const id = useUniqueId("event-space-icon-mask-");
   return <svg ref={ref} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path stroke={color} strokeLinecap="round" strokeWidth="1.5" d="M15.177 11.894a6.066 6.066 0 0 1 1.573-.415v5.271h-5.272a6.066 6.066 0 0 1 3.7-4.856Z" />
      <mask id={id} fill="#fff">
         <rect width="15" height="15" x="2.5" y="2.5" rx=".442" />
      </mask>
      <rect width="15" height="15" x="2.5" y="2.5" stroke={color} strokeLinecap="round" strokeWidth="3" mask={`url(#${id})`} rx=".442" />
      <path stroke={color} strokeLinecap="round" strokeWidth="1.5" d="M8.636 3.35v4.845a.442.442 0 0 1-.442.442H3.33M12.727 3.863v3.41M7.273 12.727h-3.41" />
   </svg>;
});
export default EventSpace;